<template>
  <IconListItem icon="orders" :label="$t('myorders.listitem.plays.label', totalNumberOfPlays)">
    {{ translatedPlays }}
  </IconListItem>
</template>

<script lang="ts" setup>
import type {
  AddOnOutput,
  HighFrequency_AddOn,
  LotteryId,
} from '#api/shared/@types/generated/backend/graphql-schema-types'

import IconListItem from '~/components/IconList/IconListItem.vue'
import { getNormalizedAddOns } from '~/utils/addons'

type MyOrdersListItemPlayProps = {
  addOns: (AddOnOutput | HighFrequency_AddOn | string)[]
  lotteryId: LotteryId
  numberOfExtraHitPlays?: number
  numberOfPlays: number
}

const { addOns, lotteryId, numberOfExtraHitPlays, numberOfPlays } =
  defineProps<MyOrdersListItemPlayProps>()

const { t } = useI18n()

const totalNumberOfPlays = computed(() => numberOfPlays + (numberOfExtraHitPlays ?? 0))

const translatedPlays = computed(() => {
  const values = []

  if (numberOfPlays) {
    values.push(t('myorders.listitem.plays.value', numberOfPlays))
  }

  if (numberOfExtraHitPlays) {
    values.push(
      t('myorders.listitem.plays.extrahit.value', {
        count: numberOfExtraHitPlays,
        name: t(`lottery.${lotteryId}.extrahit`, numberOfExtraHitPlays),
      }),
    )
  }

  if (addOns.length) {
    values.push(
      ...getNormalizedAddOns(addOns).map((addOn) =>
        addOn.toLowerCase() !== 'multiplier' ? t(`lottery.${lotteryId}.${addOn}`) : '',
      ),
    )
  }

  return values.join(' + ')
})
</script>
